<template>
  <div class="big-box">
    <div class="box-research">
      <slot name="box-img">
        <!-- <img src="@/assets/Rectangle 1114 (1).png" alt="" /> -->
        <img v-complete:src="info.image" alt="" />
      </slot>
      <div class="box-title">
        <!-- <slot name="boxP"> -->

        <p class="p2-research" @click="submitButton(info.id)">
          {{ info.title }}
          <!-- 天利教育公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录 -->
        </p>

        <P class="p1-research">
          <el-icon><Calendar /></el-icon>
          <span  style="margin-right: 34px"
            >发布时间：{{
              dayjs(info.release_time * 1000).format("YYYY-MM-DD")
            }}</span
          >

          <!-- <el-icon><Aim /></el-icon> -->
          <el-icon><Edit /></el-icon>
          <span 
            >关键词：
            <span
              v-for="(item, index) in info.tags"
              :key="index"
              style="margin-right: 10px"
              >{{ item.name }}</span
            >
          </span>
        </P>

        <p class="p3-research" @click="submitButton(info.id)">
          {{ info.intro }}
          <!-- 时值仲春，见龙在田，2月21日，恰逢农历二月初二“龙抬头”，天利教育2023年答谢晚宴在北京金隅喜来登大酒店举行。
          时值仲春，见龙在田，2月21日，恰逢农历二月初二“龙抬头”，天利教育2023年答谢晚宴在北京金隅喜来登大酒店举行。时值仲春，见龙在田，2月21日，恰逢农历二月初二“龙抬头”，天利教育2023年答谢晚宴在北京金隅喜来登大酒店举行。 -->
        </p>

        <!-- <el-button type="primary" @click="submitButton(info.id)"
          >查看详情</el-button
        > -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { Calendar, Edit } from "@element-plus/icons-vue";
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.big-box {
  // background-color: red !important;
  width: 343px;
  // height: 243px;
  margin: 0 auto;
  //  border-top:1px solid #CCCCCC;
  // padding-top: 40px;
  // padding-bottom: 40px;
  // border-bottom: 1px solid #cccccc;
}
.box-research {
  width: 100%;
  // height: 163px;
  // margin-top: 40px;
  // border:1px solid rgb(0, 157, 255);
  padding-bottom: 24px;
  border-bottom: 1px solid #cccccc;
  background-color: #ffffff;
  overflow: hidden;
  > img {
    display: block;
    width: 343px;
    height: 201px;
    // margin-right: 24px;
    border-radius: 8px;
  }

  > .box-title {
    margin-top: 16px;

    > .p1-research {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      // line-height: 20px;
      margin-bottom: 16px;
      color: #666666;
      // border:1px solid red;
      // display: flex;
      // align-items: center;
      //   margin-bottom: 5px;
      // > div {
      //   display: flex;
      //   align-items: center;
      //   margin-bottom: 5px;
      
      >span {
        margin-left: 8px;
       
      }
    }
    > .p2-research {
      height: 24px;
      line-height: 24px;
      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;

      color: #333333;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;

      cursor: pointer;
    }
    > .p3-research {
      min-height: 22px;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;

      color: #666666;
      font-size: 14px;
      font-weight: 400;
      // margin-bottom: 18px;

      cursor: pointer;
    }
  }

  .p2-research:hover,
  .p3-research:hover {
    color: #009de0;
  }
  // :deep(el-button.el-button--primary) {
  //   width: 117px !important;
  //   height: 42px !important;
  //   >span{
  //     font-size:14px;
  //     color:red;
  //   }
  // }
}
</style>
